import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { NSLoginService } from '../../Clients/NS/Services/NSLogin.service';

export const dataResolver: ResolveFn<boolean> = (route, state) => {
    const loginService = inject(NSLoginService);
    loginService.loadinitdata();
    return of(true);
};
